module.exports = __webpack_public_path__ + "img/StudentScheduleExamTimes.ba80710d.svg";